/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: liuqing
 * @LastEditTime: 2021-01-30 11:06:43
 * @Description: 
 */
import Page from './Page';
import Content from './Content';
import Scroll from './Scroll';
import Spin from './Spin';
import Circle from './Circle';
import Overlay from './Overlay';
import Modal from './Modal';
import Alert from './Alert';
import Confirm from './Confirm';
import CommonConfirm from './CommonConfirm';
import Tabbar from './Tabbar';
import Stars from './Stars';
import Button from './Button';
import Popover from './Popover';
import PopoverItem from './PopoverItem';
import Gallery from './Gallery';
import UnderEnter from './UnderEnter';
import Navbar from './Navbar';
import Video from './Video';
import Audio from './Audio';
import AudioNew from './AudioNew';
import JoinModal from './JoinModal';
import TopTip from './TopTip';

const install = function (Vue) {
  if (install.installed) {
    return;
  }

  Vue.component(Page.name, Page);
  Vue.component(Content.name, Content);
  Vue.component(Scroll.name, Scroll);
  Vue.component(Spin.name, Spin);
  Vue.component(Circle.name, Circle);
  Vue.component(Overlay.name, Overlay);
  Vue.component(Modal.name, Modal);
  Vue.component(Alert.name, Alert);
  Vue.component(Confirm.name, Confirm);
  Vue.component(CommonConfirm.name, CommonConfirm);
  Vue.component(Tabbar.name, Tabbar);
  Vue.component(Stars.name, Stars);
  Vue.component(Button.name, Button);
  Vue.component(Popover.name, Popover);
  Vue.component(PopoverItem.name, PopoverItem);
  Vue.component(Gallery.name, Gallery);
  Vue.component(UnderEnter.name, UnderEnter);
  Vue.component(Navbar.name, Navbar);
  Vue.component(Video.name, Video);
  Vue.component(Audio.name, Audio);
  Vue.component(AudioNew.name, AudioNew);
  Vue.component(JoinModal.name, JoinModal);
  Vue.component(TopTip.name, TopTip);
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
};

export {
  install,
  Page,
  Content,
  Scroll,
  Circle,
  Overlay,
  Modal,
  Alert,
  Confirm,
  CommonConfirm,
  Tabbar,
  Stars,
  Button,
  Popover,
  PopoverItem,
  Gallery,
  Navbar,
  Video,
  Audio,
  AudioNew,
  JoinModal,
  TopTip,
};



// WEBPACK FOOTER //
// ./src/components/index.js